<h2 mat-dialog-title>Select Fields</h2>
<mat-dialog-content>

  <!--Left column-->
  <div class="column" *ngIf="canEdit">
    <div class="header">

      <mat-form-field appearance="outline" class="example-full-width show-no-errors custom-label-float-above-position" style="width: 100%;">
        <mat-label><h2 style="margin: 0 0 10px 0;">Available Fields</h2></mat-label>
        <input matInput #searchBox id="search-box" (input)="search(searchBox.value)" tabindex="-1">
        <i matPrefix class="fa-duotone fa-solid fa-magnifying-glass" style="padding: 0 10px 0 10px;"></i>
        <button *ngIf="searchBox.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchBox.value='';search(searchBox.value)">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="field-container">
      <div>
        <mat-selection-list (selectionChange)="onAvailableFieldsSelectionChange($event)" [(ngModel)]="selectedAvailableFields">
          <mat-list-option *ngFor="let field of availableFieldsFiltered" class="group-text" [value]="field" (keydown)="$event.stopPropagation()">
            <div class="group-text-line">
              <div>{{field.displayTitle}}</div>
              <div *ngIf="field.fieldType === 0">
                <button mat-button disabled>
                  <mat-icon>expand_less</mat-icon>
                </button>
              </div>
            </div>
          </mat-list-option>
        </mat-selection-list>
      </div>
    </div>
  </div>
  <!--Right column-->
  <div class="column">
    <div class="header">
      @if (canEdit) {
        <mat-form-field appearance="outline" class="custom-label-float-above-position show-no-errors density-neg-2" style="width: 100%;">
          <mat-label><h2 style="margin: 0 0 1px 0; line-height: normal;">Selected Fields</h2></mat-label>
          <mat-select>
            <mat-option (click)="selectAll()">All</mat-option>
            <mat-option (click)="useDefault()">Default</mat-option>
            <mat-option (click)="deselectAll()">None</mat-option>
          </mat-select>
        </mat-form-field>
      }
      @else {
        <h2 style="margin: -10px 0 0 0">Selected Fields</h2>
      }
    </div>
    <div class="field-container">
      <div cdkDropList
           id="selectedFieldList"
           [cdkDropListData]="selectedFields"
           (cdkDropListDropped)="drop($event)"
           class="field-group-container">
        <div
             class="field-group"
             *ngFor="let field of selectedFields"
             cdkDrag
             [cdkDragData]="field" (mouseenter)="hoverFieldId = field.fieldId" (mouseleave)="hoverFieldId = null">
          <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch space-between; align-items: stretch;">
            <span style="display: flex; align-items: center;">
              <button mat-icon-button matTooltip="Drag to reorder fields">
                <mat-icon>drag_indicator</mat-icon>
              </button>
              <span>{{field.displayTitle}}</span>
            </span>

            <span *ngIf="field.fieldType === FieldType.SectionSeparator">
              <button mat-icon-button (click)="expand(field)" *ngIf="field.expanded === false">
                <mat-icon>expand_less</mat-icon>
              </button>
              <button mat-icon-button (click)="collapse(field)" *ngIf="field.expanded === true">
                <mat-icon>expand_more</mat-icon>
              </button>
            </span>
          </div>
          <div *ngIf="field.fieldId === hoverFieldId && canEdit">
            <button mat-icon-button (click)="removeFromSelected(field)">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="action-container" style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="ok()">OK</button>
  <button mat-raised-button color="secondary" mat-dialog-close *ngIf="canEdit">Cancel</button>
</mat-dialog-actions>
